// src/api/refreshToken.js
import api from './axiosInstance';

export const refreshAccessToken = async () => {
  console.log('[refreshToken] 리프레시 토큰 요청 시작');

  try {
    const response = await api.post('/api/refresh-token', {}, { withCredentials: true });
    console.log('[refreshToken] 리프레시 토큰 응답:', response);

    return response.data;
  } catch (error) {
    console.error('[refreshToken] 리프레시 토큰 요청 실패:', error);
    throw error;
  }

  
};
